module.exports = __webpack_public_path__ + "img/water side -112.99c9ea7a.jpeg";